var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "viewer",
      class: { opened: _vm.link !== null },
      attrs: { id: "image-viewer" },
      on: {
        wheel: _vm.onMouseWheel,
        "&touchstart": function ($event) {
          return _vm.onTouchStart.apply(null, arguments)
        },
        click: _vm.onClick,
      },
    },
    [
      _vm.link !== null
        ? [
            _c("button", {
              staticClass: "close-btn",
              attrs: { "aria-label": "Close" },
            }),
            _vm.previousImage
              ? _c("button", {
                  staticClass: "previous-image-btn",
                  attrs: { "aria-label": "Previous image" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.previous.apply(null, arguments)
                    },
                  },
                })
              : _vm._e(),
            _vm.nextImage
              ? _c("button", {
                  staticClass: "next-image-btn",
                  attrs: { "aria-label": "Next image" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.next.apply(null, arguments)
                    },
                  },
                })
              : _vm._e(),
            _c("a", {
              staticClass: "open-btn",
              attrs: { href: _vm.link.link, target: "_blank", rel: "noopener" },
            }),
            _c("img", {
              ref: "image",
              style: _vm.computeImageStyles,
              attrs: { src: _vm.link.thumb, alt: "" },
              on: {
                load: _vm.onImageLoad,
                mousedown: _vm.onImageMouseDown,
                "&touchstart": function ($event) {
                  return _vm.onImageTouchStart.apply(null, arguments)
                },
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }